import { FilterButton } from '../../components/admin/filter-form';
import { MoonstarListActions } from '../Moonstar/MoonstarListActions';

export const SmsMessageToolbarActions = () => (
  <MoonstarListActions hideCreate>
    <FilterButton />
  </MoonstarListActions>
);
